import React, { useEffect } from "react";
import PropTypes from "prop-types";

import useCurrentUser from "data/advisor/useCurrentUser";

import { useScreenRecorder } from "./useScreenRecorder";

export function ScreenRecorder({ children }) {
  const { startRecording, stopRecording } = useScreenRecorder();
  const user = useCurrentUser();

  useEffect(() => {
    if (user?.preferences?.sessionRecodingDisabled) {
      stopRecording();
    } else {
      startRecording();
    }
  }, [startRecording, stopRecording, user]);

  return <React.Fragment>{children}</React.Fragment>;
}

ScreenRecorder.propTypes = { children: PropTypes.node };
ScreenRecorder.defaultProps = { children: null };

export default ScreenRecorder;
